








import { defineComponent } from '@vue/composition-api';

import PanelWithWithdrawCreate from '@/components/Withdraw/PanelWithWithdrawCreate.vue';

const CreateMisc = defineComponent({
  components: {
    PanelWithWithdrawCreate,
  },
});

export default CreateMisc;
